
import { useState } from "react";
import { useParams } from "react-router-dom";
import { submitConsentData } from "../api";
import { NewShowError, NewShowSuccess } from "../projectData";
import { NewUserVirification } from "../new-otp-verification";

const OtpPopup = ({ show, setShow, values, data, reSendOtp }) => {
    const { request } = useParams();
    const [redemError, setRedemError] = useState('');
    const [success, setSuccess] = useState(null);
    const [otp, setOtp] = useState(true);

    const handleClose = () => {
        setShow(false);
        setOtp(false);
        setRedemError('');
        setSuccess(null)
    };
    const reload = () => {
        window.location.reload();
    };
    const submitConsent = () => {

        setRedemError('');
        submitConsentData({ request_token: request, ...values?.communicationType, selected_language: values?.selected_language }).then((d) => {
            setOtp(false)
            if (Number(d.code) === 1) {
                setSuccess(d);
            } else {
                setRedemError(d.message);
            }
        })
    };


    return (
        <div className="row px-4">

            {redemError ? (
                <NewShowError error={redemError} closePopup={reload} />
            ) : success ? (
                <NewShowSuccess title={"Preferences Updated Successfully"} success={success?.message} closePopup={reload} />
            ) : (
                (show && otp) && (
                    <div className="col-sm-12 mb-4">
                        <NewUserVirification
                            title="Update Communication Preferences"
                            returnFunction={submitConsent}
                            mobile={data?.phone}
                            description={`To confirm your Update Communication Preferences, please enter the OTP sent to your registered mobile number (${data?.phone.replace(/.(?=.{4})/g, '*')}).`}
                            closePOup={handleClose}
                            reSendOtp={reSendOtp}
                        />
                    </div>
                )
            )}

        </div>
    );
};

export default OtpPopup;
